import React, { Component } from 'react';


class YouTubeLink extends Component {
  render() {
    return ((navigator.userAgent || '').includes('Cloze Test App') ?
      <a
        href={`https://youtu.be/${this.props.youtubeid}`}
        target='_blank'
        rel='noopener noreferrer'
      >{this.props.title || `YouTube - ${this.props.youtubeid}`}</a> :
      <iframe width="560" height="315"
        title={this.props.title || `YouTube - ${this.props.youtubeid}`}
        src={`https://www.youtube.com/embed/${this.props.youtubeid}`}
        frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen>
      </iframe>)
  }
}

export default YouTubeLink;
